import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/organizations/settings",
    name: ROUTE_NAME.ORGANIZATION_SETTINGS,
    component: () => import("./views/OrganizationSettingsView.vue"),
  },
  {
    path: "/quick-links",
    name: ROUTE_NAME.QUICK_LINKS,
    component: () => import("./views/QuickLinksView.vue"),
  },
];
